import styled from 'styled-components'

export const Container = styled.li`
  display: inline-block;
  margin-top: 0;
`

// has to be a span
// if it holds a tooltip, this tooltip cannot be opened on hover by IE11
export const Button = styled.span`
  position: relative;
  display: flex;
  align-items: center;

  cursor: ${ (props) => (props.isLoading ? 'context-menu' : 'pointer') };

  border: 0;
  border-radius: 18px;

  background: rgba(179, 180, 179, 0.5);
  transition: background 0.2s ease-out;

  line-height: 20px;
  font-weight: 200;

  padding: 8px 38px 8px 14px;
  margin: 0 2.5px 5px;

  &::after {
    display: inline-block;
    content: '';
    position: absolute;
    top: 50%;
    right: 7px;
    transform: translateY(-50%);

    padding: 6px;
    border-radius: 50%;

    font: normal normal normal 14.54545px 'aok-icons-functional';
    font-size: 12px;
    line-height: 1;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    vertical-align: middle;

    color: ${ (props) => props.theme.colors.grau2 };
    background: transparent;
    transition: background 0.2s ease-out, color 0.2s ease-out;
  }

  &:hover,
  &:focus,
  &:active {
    outline: 0;
    background: #d8d8d8;

    &::after {
      background: ${ (props) => props.theme.colors['icon-grau2'] };
      color: ${ (props) => props.theme.colors.weiss };
    }
  }
`

export const TooltipWrapper = styled.span`
  position: relative;
  display: flex;
  align-items: center;
  margin-left: 7px;
`
